import Brightness4Icon from '@material-ui/icons/Brightness4';
import Switch from '@material-ui/core/Switch'

function Theme({ checked, themeToggler }) {
    return (
        <div className="theme">
            <div className="light-dark-mode">
                <div className="left-content">
                    <Brightness4Icon />
                </div>
                <div className="right-content">
                    <Switch
                        value=""
                        checked={checked}
                        inputProps={{ 'aria-label': '' }}
                        size="medium"
                        onClick={themeToggler} />
                </div>
            </div>
        </div>
    )
}
export default Theme